const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const fetcher = async (url: string) => {
  try {
    // Clean up the URL construction
    const cleanUrl = url.startsWith("/api") ? url.replace("/api", "") : url;
    const fullUrl = import.meta.env.DEV
      ? `/api${cleanUrl}`
      : `${API_BASE_URL}${cleanUrl}`;

    console.log("Fetching from:", fullUrl);
    const response = await fetch(fullUrl);

    if (!response.ok) {
      console.error("Fetch error:", response.status, response.statusText);
      throw new Error(
        `HTTP error! status: ${response.status} - ${response.statusText}`
      );
    }

    const data = await response.json();
    console.log("Fetch success:", data);
    return data;
  } catch (error) {
    console.error("Fetcher error:", error);
    throw error;
  }
};

export const apiRequest = async (url: string, options: RequestInit = {}) => {
  try {
    // Clean up the URL construction
    const cleanUrl = url.startsWith("/api") ? url.replace("/api", "") : url;
    const fullUrl = import.meta.env.DEV
      ? `/api${cleanUrl}`
      : `${API_BASE_URL}${cleanUrl}`;

    console.log("API request to:", fullUrl, options);
    const response = await fetch(fullUrl, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

    if (!response.ok) {
      console.error("API request error:", response.status, response.statusText);
      const errorText = await response.text();
      console.error("Error response:", errorText);

      let errorData;
      try {
        errorData = JSON.parse(errorText);
      } catch {
        errorData = { error: errorText || "Request failed" };
      }

      throw new Error(
        errorData.error || `HTTP error! status: ${response.status}`
      );
    }

    const data = await response.json();
    console.log("API request success:", data);
    return data;
  } catch (error) {
    console.error("API request error:", error);
    throw error;
  }
};
